import type { Quote } from '@smile/shared';
import { CZK } from '../lib/format';

const F = new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 3 });

/** The v2 breakdown under a price: season, filling, lead time, discount, and what the old formula would have said. */
export function QuoteBreakdown({ q }: { q: Quote }) {
  const v = q.v2;
  if (!v) return null;
  return (
    <div className="v2break">
      <span>
        sezóna <b>{v.season.title}</b>
        {v.fromBase ? ' (ceny ze základní)' : ''} · základ <b>{CZK.format(v.base)} Kč</b>
      </span>
      <span>
        obsazenost {v.booked}/{v.capacity} = <b>{F.format(v.occupancyPct)} %</b>
        {v.totalPct != null ? ` (dvůr celkem ${F.format(v.totalPct)} %${v.bandBy === 'total' ? ', rozhoduje' : ''})` : ''}
        {v.band ? ` → od ${v.band.fromPct} % ×${F.format(v.band.factor)}` : ' → ×1'} · předstih {v.leadDays} d{v.lead ? ` → od ${v.lead.fromDays} d ×${F.format(v.lead.factor)}` : ' → ×1'} ·
        násobek <b>×{F.format(v.factor)}</b> → {CZK.format(v.listPrice)} Kč
      </span>
      {v.discount && (
        <span>
          sleva {v.discount.code || v.discount.title} {v.discount.kind === 'percent' ? `${v.discount.value} %` : `${CZK.format(v.discount.value)} Kč`} = −{CZK.format(v.discount.amount)} Kč
        </span>
      )}
      {v.legacyPrice != null && (
        <span className="was">
          starý systém by řekl {CZK.format(v.legacyPrice)} Kč
        </span>
      )}
    </div>
  );
}

